import { useState } from "react";
import { SendMessageTemplate } from "../../../services/api/templates/SendMessageTemplate";

export function useSendMessage() {
  const [isLoading, setIsLoading] = useState(false);

  const sendMessage = async (template, phone, channelId) => {
    setIsLoading(true);
    try {
      const data = await SendMessageTemplate({
        template_id: template.id,
        recipient: phone,
        channel_id: channelId,
      });

      return {
        success: true,
        data,
      };
    } catch (error) {
      console.error("❌ Erro ao enviar mensagem para o telefone:", error);
      return {
        success: false,
        error,
      };
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoadingSendMessage: isLoading, sendMessage };
}
